import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=68d35774&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.styl?vue&type=style&index=0&id=68d35774&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d35774",
  null
  
)

export default component.exports